import { c as _c } from "react/compiler-runtime";
import { Link } from '@/core/i18n/navigation';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/utils';
import { SmartIcon } from './smart-icon';
export function PageHeader(t0) {
  const $ = _c(17);
  const {
    title,
    description,
    buttons,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("py-16 md:py-32", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h1 className="text-center text-4xl font-semibold lg:text-5xl">{title}</h1>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = <p>{description}</p>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== buttons) {
    t4 = buttons?.map(_temp);
    $[6] = buttons;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className="flex justify-center">{t4}</div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
    t6 = <div className="mx-auto max-w-6xl px-6"><div className="mx-auto max-w-4xl space-y-6 text-center">{t2}{t3}{t5}</div></div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <section className={t1}>{t6}</section>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp(button, idx) {
  return <Button key={idx} {...button} asChild={true}><Link href={button.url || ""} target={button.target || "_self"}>{button.icon && <SmartIcon name={button.icon} />}{button.title}</Link></Button>;
}